import React from "react";
export const ErrorContext = React.createContext({
    error: null,
    setError: ()=>null
});
const refEquality = (a, b)=>a === b;
export function useErrorContext(selector, equalityFn = refEquality) {
    const state = React.useContext(ErrorContext);
    if (state === null) {
        throw new Error("useErrorContext must be used within an ErrorContextProvider");
    }
    const selectedState = selector(state);
    const selectedStateRef = React.useRef(selectedState);
    const latestSelectedState = selectedStateRef.current;
    if (!equalityFn(latestSelectedState, selectedState)) {
        selectedStateRef.current = selectedState;
    }
    return selectedStateRef.current;
}
